{
  "FileUpload_DragAndDrop": "Drop file here or click to select file",
  "FileUpload_DropFileHere": "Drop file here",
  "FileUpload_Accepted": "File will be accepted",
  "FileUpload_Rejected": "File will be rejected",
  "FileUpload_SelectedFile": "Selected file: {}",
  "FileUpload_Validation_OverMaxSize": "File size exceeds the maximum allowed size of {}",
  "FileUpload_Validation_MaxDimensions": "File dimensions exceed the maximum allowed dimensions of {}x{}",
  "FileUpload_Validation_MinDimensions": "File dimensions are below the minimum allowed dimensions of {}x{}",
  "FileUpload_Validation_NotTransparent": "File background is not transparent",
  "NAME": "FileUploadLanguage"
}